






import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class InfoLink extends Vue {
  private name = 'info';
  private symbol = '@';
  private dom = 'mmkkyweb';
  private dot = '.';
  private tld = 'com';
  private async clickEmail() {
    window.location.href = `mailto:${this.name}${this.symbol}${this.dom}${
      this.dot
    }${this.tld}`;
  }
}
